import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { getCompany, getPreAccessTasks, getCompanyTask } from 'src/api/company';
import { useAuthenticatedUser } from 'src/hooks/useAuthenticatedUser';
import { Spinner } from '@repo/components';
import { TaskDialog } from '@repo/components';

export const Route = createFileRoute('/company_/verify/$groupId')({
	component: RouteComponent,
});

function RouteComponent() {
	const { groupId } = Route.useParams();
	const navigate = useNavigate();
	const { user: authenticatedUser, loading: userLoading } = useAuthenticatedUser();

	const { data: preAccessTasks, isLoading: tasksLoading } = useQuery({
		queryKey: ['company-pre-access-tasks', groupId],
		queryFn: () => getPreAccessTasks(groupId),
		enabled: !userLoading,
	});
	const firstTaskId = preAccessTasks?.tasks?.[0]?.id;

	const { data: task, isLoading: taskLoading } = useQuery({
		queryKey: ['company-task', groupId, firstTaskId],
		queryFn: () => getCompanyTask(groupId, firstTaskId!),
		enabled: !!firstTaskId,
	});

	if (userLoading || tasksLoading || taskLoading) {
		return <Spinner className="text-[#1E1E1E]" />;
	}

	if (!task) {
		navigate({
			to: '/company/$groupId/information',
			params: { groupId },
			replace: true,
		});
		return null;
	}

	const handleTaskDialogClose = () => {
		// Force full page reload to ensure fresh data, similar to login flow
		window.location.href = `/company/${groupId}/information`;
	};

	return <TaskDialog task={task} onClose={handleTaskDialogClose} companyId={groupId} />;
}
